import React from 'react';
import { Button, Icon, Modal, Header } from 'semantic-ui-react'

const EstaSegGral = ({btnText, open, styles, handleQuestionUpdDel}) => {

  return(
    <div>
      <Modal open={open} size="tiny" style={styles.modal} trigger={
          <Button name="btnUpdDel" id="btnUpdDel" className='ui right labeled icon button' style={styles.titBuscar} onClick={(ev)=>handleQuestionUpdDel(ev)} primary fluid>
            <i className='large edit yellow icon'></i>
            {btnText}
          </Button>
        }>
        <Header icon='edit' color='red' content={btnText} />
          <Modal.Content>
            <p>Esta usted seguro ?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>handleQuestionUpdDel(ev)}>
              <Icon dato1="No" name='remove' /> No
            </Button>
            <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>handleQuestionUpdDel(ev)}>
              <Icon dato1="Si" name='checkmark' /> Si
            </Button>
          </Modal.Actions>
      </Modal>
    </div> 
  )
}

export default EstaSegGral